HesGallery.setOptions({hostedStyles: false});
